<template>
    <md-dialog md-open-from="#custom" md-close-to="#custom" ref="confirmFeedLider">
      <md-dialog-title>Pedir feedback a lider</md-dialog-title>

      <md-dialog-content>
        <md-input-container>
            <label for="movie">Seleccione el lider</label>
            <md-select required name="lideres" id="lideres" v-model="miLider">
              <md-option v-for="lider in lideres" :key="lider['.key']" :value="lider.email">
                <md-avatar>
                  <img :src="lider.photoURL" alt="Avatar">
                </md-avatar> 
                {{lider.displayName}}
              </md-option>
            </md-select>
        </md-input-container>
        <span v-show="error" class="md-error">Seleccione un lider antes de confirmar</span>
      </md-dialog-content>

      <md-dialog-actions>
        <md-button class="md-primary" @click.native="onConfirmFeedLider('cancel', 'confirmFeedLider')">Cancel</md-button>
        <md-button class="md-primary" @click.native="onConfirmFeedLider('ok', 'confirmFeedLider')">Confirmar</md-button>
      </md-dialog-actions>
      <md-snackbar @close="clearInput()" :md-position="'bottom center'" ref="toastLider" :md-duration="4000">
        <span>El feedback se pidio correctamente a: {{miLider}}</span>
      </md-snackbar>
    </md-dialog>
</template>

<script>
import FeedbacksService from '../services/feedbacks'
import FluxerService from '../services/fluxer'
import NotificationsService from '../services/notifications'

export default {
  name: 'feedback-lider',
  props: ['currentFluxer'],
  data () {
    return {
      miLider: '',
      error: false
    }
  },
  firebase: function () {
    return {
      lideres: FluxerService.getLideres()
    }
  },
  methods: {
    confirmFeedLider () {
      this.miLider = this.currentFluxer.lider
      this.$refs['confirmFeedLider'].open()
    },
    onConfirmFeedLider (type, ref) {
      if (type === 'ok') {
        if (!this.miLider) {
          this.error = true
        } else {
          this.error = false
          let miLider = this.miLider
          let currentFluxer = this.currentFluxer
          FeedbacksService.create(this.currentFluxer, this.miLider, 'lider').then((feedId) => {
            NotificationsService.solicitarFeedback(feedId, miLider.email, currentFluxer)
            this.$refs.toastLider.open()
            this.$refs[ref].close()
          })
        }
      } else {
        this.error = false
        this.clearInput()
        this.$refs[ref].close()
      }
    },
    clearInput () {
      this.miLider = ''
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .md-error {
    color: red;
  }
</style>



// WEBPACK FOOTER //
// FeedbackLider.vue?05c3b433